import { I5G, IProduct } from "../../fetchOrderProducts";

export function is5G(product: IProduct): product is I5G {
  return "specificationId" in product && product.specificationId === "5G";
}
